import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import EDCMainPanel from "../../Components/EDC/EDCMainPanel";
import EIWRSSidebar from "./EIWRSSidebar";
import ResizerXManager from "../../Components/ResizerXManager/ResizerXManager";
import { ResizableX, ResizableY } from "../Modules/ResizeTable/Layouts";
import Navbar from "../Navbar";
import Footer from "../Footer";
import SubjectScreening from "./SubjectScreening/SubjectScreening";
import { ResizablexContext } from "../Modules/ResizeTable/ResizeTable";
import EIWRSDashboard from "./Dashboard/EIWRSDashboard";
import Randomization from "./Randomization/Randomization";
import EnvelopeView from "./EnvelopeView/EnvelopeView";
import Reports from "./Reports/Reports";
import AuditTrail from "./AuditTrail/AuditTrial";
import DepotMetadataDataList from "./DepotManagement/DepotMetadata/DepotMetadataDataList";
import DepotDataList from "./DepotManagement/DepotData/DepotDataList";
import SiteInventoryDataList from "./SiteInventory/SiteInventoryDataList";
import StudySiteShipmentDataList from "./Shipments/ShipmentManagement/StudySiteShipmentDataList";
import StudyTemperatureMetadataDataList from "./Shipments/TemperaturerMetadata/StudyTemperatureMetadataDataList";
import CorierDataList from "./Shipments/CorierManagement/CorierData/CorierDataList";
import CorierMetadataDataList from "./Shipments/CorierManagement/CorierMetadata/CorierMetadataDataList";
import AssignDepotSite from "./SiteInventory/AssignDepotSite";
import StudyKitTypeMetadataDataList from "./KitManagement/KitTypeMetadata/StudyKitTypeMetadataDataList";
import StudyKitPreparationDataList from "./KitManagement/KitPreparation/StudyKitPreparationDataList";
import StudyKitPreparationOverview from "./KitManagement/KitPreparation/StudyKitPreparationOverview";
import StudyKitInventoryDataList from "./KitManagement/KitPreparation/StudyKitInventoryDataList";
import StudyRandomizationSchemaDataList from "./RandomizationSchemas/StudyRandomizationSchemaDataList";
import AssignRandomizationSchemaSite from "./RandomizationSchemas/AssignRandomizationSchemaSite";
import StudyKitBatchNumberMetadataDataList from "./KitManagement/KitBatchNumberMetadata/StudyKitBatchNumberMetadataDataList";
import StudyKitQuanrantineReasonDataList from "./KitManagement/KitQuanrantineReason/StudyKitQuanrantineReasonDataList";
import StudyUnblindingReasonDataList from "./UnblindManagement/UnblindingReason/StudyUnblindingReasonDataList";
import StudyUnblindingRequestTypeDataList from "./UnblindManagement/UnblindingRequestType/StudyUnblindingRequestTypeDataList";
import DerivedVariableDataList from "../EDCManagement/StudySettings/DerivedVariable/DerivedVariableDataList";
import StudyKitSchemaManagementDataList from "./KitManagement/KitSchemaManagement/StudyKitSchemaManagementDataList";
import StudyUnblindRequestManagementDataList from "./UnblindManagement/UnblindRequestManagement/StudyUnblindRequestManagementDataList";
import StudyUnblindEmergencyRequestDataList from "./UnblindManagement/UnblindEmergencyRequest/StudyUnblindEmergencyRequestDataList";
import StudyKitMetadataDataList from "./KitManagement/KitMetadata/StudyKitBatchNumberMetadataDataList";

const EIWRSManagement = () => {
  const [studyTabs, setStudyTabs] = useState([]);
  const { studyId } = useParams();
  const [resizingColumn, setResizingColumn] = useState(null);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const tableRef = useRef(null);
  const [collapseSidebar, setCollpaseSidebar] = useState(false);
  const resizableX = useContext(ResizablexContext);

  useEffect(() => {
    resizableX();
  });

  useEffect(() => {
    const onMouseMove = (e) => {
      if (resizingColumn !== null) {
        const width = startWidth.current + (e.pageX - startX.current);
        const th = tableRef.current.querySelector(
          `th:nth-child(${resizingColumn + 1})`,
        );
        th.style.width = `${width}px`;
        tableRef.current.classList.add("resizing");
      }
    };

    const onMouseUp = () => {
      setResizingColumn(null);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    if (resizingColumn !== null) {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [resizingColumn]);

  const onMouseDown = (e, columnIndex) => {
    setResizingColumn(columnIndex);
    startX.current = e.pageX;
    startWidth.current = e.target.offsetWidth;
    document.body.style.userSelect = "none";
    tableRef.current.querySelectorAll("th").forEach((column, index) => {
      if (index !== columnIndex) {
        column.style.width = `${column.offsetWidth}px`;
      }
    });
  };

  const handleAddNewTab = (studyTabName, icon, studyTabId) => {
    let newTab = {
      studyTabId: studyTabId,
      studyTabName: studyTabName,
      icon: icon,
      openDT: new Date(),
      status: "active",
    };
    const updatedTabs = studyTabs?.map((studyTab) => ({
      ...studyTab,
      status: "inactive",
    }));
    const existTab = studyTabs?.some(
      (studyTab) => studyTab.studyTabId === studyTabId,
    );
    if (existTab) {
      updatedTabs.forEach((element) => {
        if (element.studyTabId === studyTabId) {
          element.status = "active";
          element.studyTabName = studyTabName;
        }
      });
      setStudyTabs(updatedTabs || []);
    } else {
      setStudyTabs([...updatedTabs, newTab] || []);
    }
  };

  const checkActiveTab = (studyTabId) => {
    return studyTabs?.some(
      (item) => item.studyTabId === studyTabId && item.status === "active",
    );
  };

  const checkHomeActiveTab = () => {
    return studyTabs?.some((item) => item.status === "active");
  };

  const activeStudyTab = studyTabs?.some((item) => item.status === "active");

  useEffect(() => {
    const savedStudyTabs = JSON.parse(localStorage.getItem("studyTabs"));
    if (savedStudyTabs) {
      setStudyTabs(savedStudyTabs || []);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("studyTabs", JSON.stringify(studyTabs));
  }, [studyTabs]);

  return (
    <>
      <Navbar />
      <ResizableX>
        <div style={{ width: collapseSidebar ? 45 : 250 }}>
          <section className="middle-content">
            <EIWRSSidebar
              handleAddNewTab={handleAddNewTab}
              checkActiveTab={checkActiveTab}
              studyId={studyId}
              collapseSidebar={collapseSidebar}
            />
          </section>
        </div>
        <ResizerXManager collapseSidebar={collapseSidebar} />
        <ResizableY>
          <section className="middle-content " id="dashboard-section">
            <div className="inner-cont">
              <EDCMainPanel
                setStudyTabs={setStudyTabs}
                studyTabs={studyTabs}
                showSidebar
                activeStudyTab={activeStudyTab}
                collapseSidebar={collapseSidebar}
                setCollpaseSidebar={setCollpaseSidebar}
              />
              {!checkHomeActiveTab() && (
                <EIWRSDashboard tableRef={tableRef} onMouseDown={onMouseDown} />
              )}

              {checkActiveTab("subjectScreening") && (
                <SubjectScreening
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveTab("randomizationSchemas") && (
                <StudyRandomizationSchemaDataList
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveTab("assignrandomizationSchemaSite") && (
                <AssignRandomizationSchemaSite
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveTab("assignedBasedRandomization") && (
                <DerivedVariableDataList
                  category="assignBasedRandomization"
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveTab("randomization") && (
                <Randomization tableRef={tableRef} onMouseDown={onMouseDown} screenType="eiwrs" />
              )}
              {checkActiveTab("envelopeView") && (
                <EnvelopeView onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitOverview") && (
                <StudyKitPreparationOverview onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitPreparation") && (
                <StudyKitPreparationDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitInventory") && (
                <StudyKitInventoryDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("manageDepotMetadata") && (
                <DepotMetadataDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("manageShipment") && (
                <StudySiteShipmentDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("courierMetaData") && (
                <CorierMetadataDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("courierData") && (
                <CorierDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("temperatureData") && (
                <StudyTemperatureMetadataDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("manageDepot") && (
                <DepotDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("assignDepotSite") && (
                <AssignDepotSite onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("siteInventory") && (
                <SiteInventoryDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitSchemaManagement") && (
                <StudyKitSchemaManagementDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitMetadata") && (
                <StudyKitMetadataDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitTypeMetadata") && (
                <StudyKitTypeMetadataDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitQuanrantineReasonMeta") && (
                <StudyKitQuanrantineReasonDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("kitBatchNumberMetadata") && (
                <StudyKitBatchNumberMetadataDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("unblindingRequests") && (
                <StudyUnblindRequestManagementDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("unblindingReasonMetadata") && (
                <StudyUnblindingReasonDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("unblindingRequestTypeMetadata") && (
                <StudyUnblindingRequestTypeDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("emergencyUnblinding") && (
                <StudyUnblindEmergencyRequestDataList onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("eiwrsReports") && (
                <Reports onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
              {checkActiveTab("eiwrsAuditTrail") && (
                <AuditTrail onMouseDown={onMouseDown} tableRef={tableRef} />
              )}
            </div>
          </section>
        </ResizableY>
      </ResizableX>
      <Footer />
    </>
  );
};

export default EIWRSManagement;
